import { AxiosResponse } from 'axios';

import { api } from '../../http';
import {
  BaseFilter,
  Calendar,
  PageRequest,
  PageResponse,
  TreeNodeBase
} from '../../types/interfaces';

import { ApiResponse } from './interfaces';

export const CalendarService = {
  getAll(
    params: PageRequest & {
      sortBy?: string;
      sortDirection?: string;
      parsedFilters?: BaseFilter[];
      fillers?: string;
    }
  ): Promise<AxiosResponse<PageResponse<Calendar> | undefined>> {
    const searchParams = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      if (params[key]) {
        searchParams.append(key, String(params[key]));
      }
    });

    return api
      .get<ApiResponse<PageResponse<Calendar>>>('Calendar', {
        params: searchParams
      })
      .then((resp) => {
        if (resp.data.isSuccess) {
          // "Разворачиваем" в старую форму
          return { ...resp, data: resp.data.value };
        } else {
          // При ошибке возвращаем data: undefined (либо можно выбросить ошибку)
          return { ...resp, data: undefined };
        }
      });
  },

  getById(id: number): Promise<AxiosResponse<Calendar | undefined>> {
    return api.get<ApiResponse<Calendar>>(`Calendar/${id}`).then((resp) => {
      if (resp.data.isSuccess) {
        return { ...resp, data: resp.data.value };
      } else {
        return { ...resp, data: undefined };
      }
    });
  },

  update(
    id: number,
    Calendar: Calendar
  ): Promise<AxiosResponse<ApiResponse<Calendar>>> {
    return api.put<ApiResponse<Calendar>>(`Calendar/${id}`, Calendar);
  },

  delete(id: number): Promise<AxiosResponse<ApiResponse<null>>> {
    return api.delete<ApiResponse<null>>(`Calendar/${id}`);
  },

  create(Calendar: Calendar): Promise<AxiosResponse<ApiResponse<Calendar>>> {
    return api.post<ApiResponse<Calendar>>('Calendar', Calendar);
  },

  getForSelection(): Promise<AxiosResponse<ApiResponse<TreeNodeBase[]>>> {
    return api.get<ApiResponse<TreeNodeBase[]>>('Calendar', {
      params: { ForSelection: 'true' }
    });
  }
};
